<rt-button [pressed]="isActive" variant="plain" size="small">
  <rt-emoji [emoji]="reaction" [size]="14"></rt-emoji>
  <span class="counter" margin-left-small-x>{{ counter }}</span>
</rt-button>
